<template>
  <WeContainer v-if="ready" header="true" v-bind:actions="actions">
    <WeTable
      v-bind:index="false"
      v-bind:data="slider.list"
      v-bind:columns="columns"
      v-bind:actions="tableActions"
      v-on:on-action="onAction"
      v-on:on-switch="onSwitch"
    ></WeTable>
  </WeContainer>
  <WeLoading v-else />
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  name: "List",
  data() {
    return {
      ready: false,
      actions: [
        {
          text: "Yeni Slide",
          path: "sliders/new",
        },
        {
          text: "Çöp Kutusu",
          class: "btn btn-outline-danger float-right",
          icon: "fas fa-trash",
          path: "sliders/trash",
        },
      ],
      tableActions: [
        {
          icon: "fas fa-edit",
          class: "btn-outline-primary",
          action: "edit",
        },
        {
          icon: "fas fa-trash",
          class: "btn-outline-danger ml-2",
          action: "remove",
        },
      ],
      columns: [{ name: "title", th: "Slider Başlık", type: "string" }],
    };
  },
  methods: {
    ...mapActions("slider", ["getList", "delete", "isActive"]),
    onAction(data) {
      if (data.key == "remove") {
        this.onDelete(data.row, data.index);
      } else if (data.key == "edit") {
        this.onEdit(data.row);
      }
    },
    onEdit(row) {
      this.$router.replace("sliders/detail/" + row.id);
    },
    onDelete(row) {
      let message = `${row.title} adlı Slide'ı silmek istediğinize emin misiniz ?`;

      this.$swal({
        title: message,
        html: `Bu işlemi <b class="text-danger">Çöp Kutusu</b> bölümünden geri alabilirsiniz.`,
        icon: "question",
        showCancelButton: true,
        cancelButtonText: "İptal",
        confirmButtonText: "Sil",
      }).then((confirm) => {
        if (confirm.isConfirmed) {
          this.delete({
            id: row.id,
            onSuccess: (result) => {
              if (result && result.data && result.data.status !== "error") {
                this.$toast.success("Slide Başarıyla Silindi");
                helper.arrayRemove(this.slider.list, "id", row.id);
              } else {
                this.$swal({
                  title: "Slide Silinemedi",
                  text: result.data.message,
                  icon: "error",
                  confirmButtonText: "Tamam",
                });
              }
            },
          });
        }
      });
    },
    onSwitch(data) {
      this.isActive(data);
    },
  },
  computed: {
    ...mapState(["slider", "shared"]),
  },
  mounted() {
    this.slider.list = [];
    this.getList({
      onFinish: () => {
        this.ready = true;
      },
    });
  },
};
</script>
